import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=410f2a7f&"
import script from "./FolderList.vue?vue&type=script&lang=js&"
export * from "./FolderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports